module.exports = "/images/user-icon.svg?f993f6efa1c44f3703f9828ed71a796f";